<template>
  <div class="case-detail-data-list-gene-preview-select-form-page col-block width-full" :style="{ flex: 1 }">
    <div class="preview-main-container col-block width-full">
      <div class="preview-category-container col-block width-full">
        <div class="preview-category-block col-block width-full" v-for="(categoryOption, coindex) in previewSelectOptions.categoryOptions" :key="coindex">
          <div v-if="categoryOption.title !== '__DEFAULT'" class="preview-category-title-container row-block">
            <div
              class="preview-category-title-block row-block"
              :class="{
                selectable: groupSelect,
                disabled: groupSelect && (
                  (categoryOption.selectCount === categoryOption.optionCount) && ((selectedDatas.length - categoryOption.optionCount) < selectedRange[0]) ||
                  (categoryOption.selectCount !== categoryOption.optionCount) && ((selectedDatas.length + (categoryOption.optionCount - categoryOption.selectCount)) > selectedRange[1])
                )
              }"
              @click="e => !e.currentTarget.className.split(' ').includes('disabled') && groupSelect && setResultDatas(categoryOption.options)">
              <template v-if="groupSelect">
                <div class="preview-category-title-mask"></div>
                <img :src="categoryOption.selectCount ? (categoryOption.selectCount === categoryOption.optionCount) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')">
              </template>
              <div class="preview-category-title">{{ $t(categoryOption.title) }}</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="preview-category-group-container col-block width-full" :class="{ group: groupSelect }">
            <div class="preview-category-group-block row-block stretch" v-for="(groupOption, goindex) in categoryOption.groupOptions" :key="goindex">
              <div v-if="groupOption.title !== '__DEFAULT'" class="preview-category-group-cell-container title row-block" :style="{ width: '146px' }">
                <div :style="{ flex: 1 }"></div>
                <div class="preview-category-group-cell-block row-block">
                  <div class="preview-category-group-cell break-line">{{ $t(groupOption.title) }}</div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="preview-category-group-cell-container row-block" :style="{ flex: 1 }">
                <div class="preview-category-group-form-list-container row-block flex-start flex-wrap">
                  <div
                    class="preview-category-group-form-container row-block"
                    v-for="(formOption, foindex) in groupOption.options"
                    :key="foindex"
                    :class="{
                      disabled: (
                        selectedMap[formOption.key] && (selectedDatas.length <= selectedRange[0]) ||
                        !selectedMap[formOption.key] && (selectedDatas.length >= selectedRange[1])
                      )
                    }"
                    @click="e => !e.currentTarget.className.split(' ').includes('disabled') && setResultDatas([formOption])"
                  >
                    <div class="preview-category-group-form-mask"></div>
                    <img :src="selectedMap[formOption.key] ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
                    <div class="preview-category-group-form-title">{{ $t(formOption.title) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { reportPreviewOptions, reportPreviewRangeData } from '../../constants/global/data'
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    defaultDatas: {
      type: Array,
      required: true
    },
    displayType: {
      type: String,
      required: true
    },
    variants: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    selectedMap () {
      return this.defaultDatas.reduce((map, key) => ({ ...map, [key]: true }), {})
    },
    selectedDatas () {
      let selectedDatas = this.previewSelectOptions.options.filter(option => this.selectedMap[option.key])
      this.$emit('update', selectedDatas)
      return selectedDatas
    },
    selectedRange () {
      return reportPreviewRangeData[this.displayType]
    },
    groupSelect () {
      return {
        'ps': false,
        'pd': true
      }[this.displayType]
    },
    previewSelectOptions () {
      let previewSelectOptions = reportPreviewOptions[this.displayType].filter(option => (
        !option.old &&
        (option.selectDisplay || (() => true))(this.variants, this.user)
      ))
      previewSelectOptions = {
        options: previewSelectOptions,
        categoryOptions: groupBy(previewSelectOptions, categoryOption => categoryOption.category).map(groupOptions => ({
          title: groupOptions[0].category,
          options: groupOptions,
          optionCount: groupOptions.length,
          selectCount: groupOptions.reduce((count, groupOption) => count + (this.selectedMap[groupOption.key] ? 1 : 0), 0),
          groupOptions: groupBy(groupOptions, groupOption => groupOption.group).map(formOptions => ({
            title: formOptions[0].group,
            options: formOptions
          }))
        }))
      }
      return previewSelectOptions
    }
  },
  methods: {
    setResultDatas (datas) {
      let resultDatas = [...this.defaultDatas]
      let dataKeys = datas.map(data => data.key)
      resultDatas = dataKeys.every(key => this.selectedMap[key]) ? resultDatas.filter(resultData => !dataKeys.includes(resultData)) : resultDatas.concat(dataKeys).filter((x, i, s) => s.indexOf(x) === i)
      this.$emit('dataUpdate', resultDatas)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/genePreviewSelectForm.vue